export const environment = {
    production: true,
    identityUrl: 'https://identity-v2.nside.io',
    withCredentials: true,
    angularAppUrl: 'https://tips-dash-v2-prod.nside.io',
    apiBaseUrl: 'https://tips-v2-prod.nside.io',
    assessApiBaseUrl: 'https://assess-api-prod.nside.io'
};
